module.exports = __webpack_public_path__ + "assets/26450e2ce86a0a91492a2d87450c6754.svg";